<template>
    <div class="banner banner__testimonial">
            <div class="banner__background">
                <Media v-if="props.backgroundImage" :media="props.backgroundImage" defaultMediaType="image" alt="Background Image" media-classes="banner__image banner__image--desktop" />
                <Media v-if="props.mobileBackgroundImage" :media="props.mobileBackgroundImage" defaultMediaType="image" alt="Our Commitment to Service" media-classes="banner__image banner__image--mobile" />
            </div>
            <div class="banner__content">
                <div class="banner__layout center-align">
                    <div :class="`banner__eyebrow eyebrow text-${props.eyebrow.color}`">{{ props.eyebrow.text }}</div>
                    <h2 :class="`banner__headline headline-m text-${props.testimonialHeadline.color}`">{{ props.testimonialHeadline.text }}</h2>
                    <p :class="`banner__description paragraph-feature text-${props.testimonialName.color}`">{{ props.testimonialName.text }}</p>
                </div>
            </div>
        </div>
</template>
<script lang="ts" setup>
import Media from "@/components/Media.vue";

let props = defineProps({
    backgroundImage: {
        type: String,
        default: ""
    },
    mobileBackgroundImage: {
        type: String,
        default: ""
    },
    eyebrow: {
        type: Object,
        default(){
            return {};
        }
    },
    testimonialHeadline: {
        type: Object,
        default(){
            return {};
        }
    },
    testimonialName: {
        type: Object,
        default(){
            return {};
        }
    }
});
</script>